import { Injectable } from '@angular/core';
import { ApiService } from '../../core/api.service';
import { Observable } from 'rxjs';
import { Testemunho, TestemunhoListDto, TestemunhoPagedResponse } from './testemunho.model';

@Injectable({ providedIn: 'root' })
export class TestemunhoService {
  constructor(private api: ApiService) {}

  listByFornecedor(fornecedorId: string, page = 1, pageSize = 10): Observable<TestemunhoPagedResponse<TestemunhoListDto>> {
    return this.api.get(`/testemunhos/fornecedor/${fornecedorId}`, { page, pageSize }) as Observable<any>;
  }

  get(id: string): Observable<Testemunho> {
    return this.api.get(`/testemunhos/${id}`) as Observable<any>;
  }

  create(payload: { nome: string; descricao: string; fornecedorId: string }): Observable<Testemunho> {
    return this.api.post('/testemunhos', payload) as Observable<any>;
  }

  // Admin endpoints
  adminList(page = 1, pageSize = 20, fornecedorId?: string, status?: string, rating?: number): Observable<TestemunhoPagedResponse<Testemunho>> {
    const params: any = { page, pageSize };
    if (fornecedorId) params.fornecedorId = fornecedorId;
    if (status) params.status = status;
    if (rating) params.rating = rating;
    return this.api.get('/admin/testemunhos', params) as Observable<any>;
  }

  adminDelete(id: string) {
    return this.api.delete(`/admin/testemunhos/${id}`);
  }

  adminUpdate(id: string, payload: { nome: string; descricao: string; fornecedorId: string }): Observable<Testemunho> {
    return this.api.put(`/admin/testemunhos/${id}`, payload) as Observable<any>;
  }

  adminTogglePublish(id: string, isPublished: boolean) {
    return this.api.put(`/admin/testemunhos/${id}`, { isPublished }) as Observable<any>;
  }
}
